const isAdmin = state => state.isAdmin;

export default isAdmin;
